import type { FaireProductEntity } from "../../entity_types/product";

export const p_5fswz79wa5: FaireProductEntity = {
  token: "p_5fswz79wa5",
  type: "product",
  name: "Bova's Bakery Boston - Storefront Art Print - New England",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/71c3bda6ece61eee349be120346dc0b75665b33761f5c1d26e22cc08afac12e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/add9c297d15858ae2cc5ddffe57f7276b37e6bf0d344856c7990284124266f25.jpeg",
    "https://cdn.faire.com/fastly/7237b22cbfb8f813f4983a18be22fe19c69678e5eefec40d697c10981591f7c7.jpeg",
    "https://cdn.faire.com/fastly/4ddefdd783d746fb56a86c66540f64c683366d54e9c8ab049b87bb38f0fa5d39.jpeg",
    "https://cdn.faire.com/fastly/b61d4f1fd54f6adf640046dd8d0459779cdda680b345a8d965fcb23ab60648c2.png",
    "https://cdn.faire.com/fastly/369923566b3d695a2034a3e6108f3f03432378e7f0e59e77d31edc7e94ec4708.jpeg",
    "https://cdn.faire.com/fastly/9f4921eed41b4a4ed44deeda6b6fa435df325d9adfdba597a56c0e04e7c2f05e.jpeg"
  ],
  priceDollars: 10,
  description: "Fine art print of Bova's Bakery in Boston's North End, originally created with gouache and ink. This nostalgic storefront illustration appeals to locals, tourists, or anyone who loves authentic neighborhood charm.\n\nAll art prints are painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”, 8”x10”, 11”x14”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:12.740Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
